import { Middleware } from "redux";
import { AppState } from "../redux/AppTypes";
import service from "./HarvestService";
import {
  DoFetchHarvestBudget,
  DO_FETCH_HARVEST_PROJECTS,
  DoFetchHarvestUsers,
  DO_FETCH_HARVEST_BUDGET,
  DO_FETCH_HARVEST_USERS,
  FAIL_HARVEST_BUDGET,
  FAIL_HARVEST_PROJECTS,
  FAIL_HARVEST_USERS,
  FetchHarvestBudget,
  FetchHarvestProjects,
  FetchHarvestUsers,
  FETCH_HARVEST_BUDGET,
  FETCH_HARVEST_PROJECTS,
  FETCH_HARVEST_USERS,
  LoadHarvestBudget,

  LoadHarvestUsers,
  LOAD_HARVEST_BUDGET,
  LOAD_HARVEST_PROJECTS,

  LOAD_HARVEST_USERS
} from "./HarvestTypes";
import { shouldFetch } from "../redux/LoadStatus";

const fetchProjectsMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: FetchHarvestProjects) => {
    next(action);
    if (action.type === FETCH_HARVEST_PROJECTS) {
      const status = store.getState().harvest.projectsStatus;
      if (shouldFetch(status, action.force)) {
        store.dispatch({
          type: DO_FETCH_HARVEST_PROJECTS,
        });
        try {
          const projects = await service.fetchProjects();
          store.dispatch({
            type: LOAD_HARVEST_PROJECTS,
            projects,
          });
        } catch (error) {
          store.dispatch({
            type: FAIL_HARVEST_PROJECTS,
            error,
          });
        }
      }
    }
  };

const doFetchBudgetMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: DoFetchHarvestBudget) => {
    next(action);
    if (action.type === DO_FETCH_HARVEST_BUDGET) {
      try {
        const budget = await service.fetchBudget(action.year, action.month);
        const load: LoadHarvestBudget = {
          type: LOAD_HARVEST_BUDGET,
          year: action.year,
          month: action.month,
          budget,
        };
        store.dispatch(load);
      } catch (error) {
        store.dispatch({
          type: FAIL_HARVEST_BUDGET,
          year: action.year,
          month: action.month,
          error,
        });
      }
    }
  };

const fetchBudgetMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: FetchHarvestBudget) => {
    next(action);
    if (action.type === FETCH_HARVEST_BUDGET) {
      const now = new Date();
      const requestedDate = new Date(action.year, action.month);
      // ignore future budgets
      if (requestedDate.getTime() > now.getTime()) {
        return;
      }
      const key = `${action.year}-${action.month}`;
      const status = store.getState().harvest.budgetStatus[key];
      if (shouldFetch(status, action.force)) {
        const load: DoFetchHarvestBudget = {
          type: DO_FETCH_HARVEST_BUDGET,
          year: action.year,
          month: action.month,
        };
        store.dispatch(load);
      }
    }
  };

const fetchHarvestUsersMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: FetchHarvestUsers) => {
    next(action);
    if (
      action.type === FETCH_HARVEST_USERS &&
      shouldFetch(store.getState().harvest.users.status, action.force)
    ) {
      const doFetch: DoFetchHarvestUsers = {
        type: DO_FETCH_HARVEST_USERS,
      };
      store.dispatch(doFetch);
    }
  };

const doFetchUsersMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: DoFetchHarvestUsers) => {
    next(action);
    if (action.type === DO_FETCH_HARVEST_USERS) {
      try {
        const users = await service.fetchUsers();
        const load: LoadHarvestUsers = {
          type: LOAD_HARVEST_USERS,
          items: users,
        };
        store.dispatch(load);
      } catch (error) {
        store.dispatch({
          type: FAIL_HARVEST_USERS,
          error,
        });
      }
    }
  };

const middlewares = [
  doFetchBudgetMiddleware,
  doFetchUsersMiddleware,
  fetchBudgetMiddleware,
  fetchHarvestUsersMiddleware,
  fetchProjectsMiddleware,
];
export default middlewares;
